<template>
  <div class="pageTitle">
    <div class="main">
      <!-- position:absolute; display: block; -->
      <a v-if="showBack" v-on:click="goback" style="    float: left; ">
        <!-- <mu-icon value="keyboard_arrow_left" color="white"/> -->
        <img src="../../static/goback.png" style="width:0.3rem;margin-left:0.3rem">
      </a>
      <span style="    position: initial;" @click="clickTitle">
        {{title}}
        <img v-if="showTitleIcon" src="../../static/components/pageTitle/arr_down.png">
      </span>
      <!-- 右边的图 -->
      <a v-if="RightImgName != ''" style="float: right; margin-right: 0.3rem;">
        <div v-on:click="GoIndex()">
          <img
            v-if="RightImgName == 'home'"
            src="../../static/err/home.png"
            style="width:0.5rem;padding:0 0.1rem "
          >
        </div>
      </a>
      <a class="rightGo" @click.stop="clickRight" v-if="showRight">
        <span v-if="rightTitle != ''">{{rightTitle}}</span>
        <img v-else src="../../static/question.png">
      </a>
    </div>
    <div class="bottomExtend" v-if="bottomExtend"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: {
    //标题
    title: {
      type: String,
      default: "默认标题"
    },
    //返回箭头
    showBack: {
      type: Boolean,
      default: true
    },
    //标题
    RightImgName: {
      type: String,
      default: ""
    },
    showRight: {
      type: Boolean,
      default: false
    },
    rightTitle: {
      type: String,
      default: ""
    },
    rightUrl: {
      type: String,
      default: ""
    },
    showTitleIcon: {
      type: Boolean,
      default: false
    },
    titleIcon: {
      type: String,
      default: ""
    },
    //底部拓展
    bottomExtend: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    GoIndex() {
      this.$router.push({ path: "/home/index" });
    },
    goback() {
      this.$router.go(-1);
    },
    clickRight() {
      this.$emit("rightHandler");
    },
    clickTitle() {
      this.$emit("titleHandler");
    }
  },
  computed: {}
};
</script>

<style lang="less" scoped>
@import "../assets/theme.less";
.pageTitle {
  z-index: -1;
}
.main {
  .leftBack {
    height: 0.88rem;
    position: absolute;
    left: 0.3rem;
    display: flex;
    .mu-icon {
      margin: auto 0;
    }
  }
  .centerTitle {
    display: inline-flex;
    img {
      width: 0.3rem;
      height: 0.3rem;
      margin: auto 0;
    }
  }
  .rightGo {
    position: absolute;
    height: 0.88rem;
    color: #fff;
    right: 0.3rem;
    top: 0px;
    font-size: 0.3rem;
    font-weight: 500;
    display: flex;
    img {
      height: 0.4rem;
      height: 0.4rem;
      margin: auto 0;
    }
  }
  color: white;
  height: 0.88rem;
  line-height: 0.88rem;
  font-size: 0.36rem;
  background-color: @primaryColor;
  font-weight: 600;
  text-align: center;
}
.bottomExtend {
  width: 7.5rem;
  height: 0.5rem;
  background-color: @primaryColor;
}
</style>


// WEBPACK FOOTER //
// pageTitle.vue?14e29eb0